<template>
	<div>
		<navTitle><div class="pageTitle">推荐机构</div></navTitle>

		<swiper ref="myHomeSwiper" class="home-swiper" :options="myHomeSwiperOptions">
			<swiper-slide v-for="(item, index) in detail.pics" :key="index" class="home-swiper-slide"><img :src="item" alt="" /></swiper-slide>

			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>

		<div class="office">
			<div class="name">{{detail.title}}</div>
			<div class="openTime flex flex-align-center">
				<img src="@/static/images/my/time.png" alt="" />
				<div>{{detail.work_time}}</div>
			</div>
			<div class="location flex flex-align-center">
				<img src="@/static/images/my/location.png" alt="" />
				<div @click="showPicker = true">
					<span>{{detail.distance | distance}} | </span>
					<span>
						{{detail.address}}
					</span>
				</div>
			</div>

			<div class="contact flex flex-align-center flex-jus-between">
				<div>联系人：{{detail.contacts}}</div>
				
				<a :href="'tel:'+detail.phone">
					<div class="contact-btn flex flex-align-center">
						<img src="@/static/images/my/phone.png" alt="" />
						<div>拨打咨询</div>
					</div>
				</a>
			</div>
			
			<div class="introduce">介绍</div>
			
			<div class="introduce-content" v-html="detail.content"></div>
			
			<van-popup v-model="showPicker" round position="bottom">
				<van-picker
					title="选择地图"
					show-toolbar
					:columns="maps"
					@confirm="onConfirm"
				/>
			</van-popup>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			id: '',
			detail: {},
			myHomeSwiperOptions: {
				autoplay: {
					delay: 3000 //1秒切换一次
				},
				pagination: {
					el: '.swiper-pagination'
				}
			},
			showPicker: false,
			maps: [
				'腾讯地图',
				'高德地图',
				'百度地图'
			]
		};
	},
	filters: {
		distance(val) {
			if (val*1 < 1000) {
				return val*1 + 'm'
			} else {
				return (val / 1000).toFixed(2) + 'km'
			}
		}
	},
	created() {
		this.id = this.$route.query.id
		this.getData()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '推荐机构',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getData() {
			this.$get('api/actile/gettWorkDetails', {
				lat: localStorage.getItem('latitude'),
				lng: localStorage.getItem('longitude'),
				id: this.id
			}).then(res => {
				this.detail = res.data
			})
		},
		onConfirm(e) {
			let url = '';
			let lat = this.detail.lat
			let lng = this.detail.lon
			let address = this.detail.address
      switch(e) {
				case '腾讯地图':
						url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' +  lng +';addr:'+ address +';title:地址&referer=keyfree';
						break;
				case '高德地图':
						url = 'https://uri.amap.com/marker?position='+ lng + ',' + lat +'&name='+ address +'&callnative=1';
						break;
				case '百度地图':
						url = 'http://api.map.baidu.com/marker?location=' + lat + ',' +  lng +'&title=地址&content='+ address +'&output=html&src=webapp.reformer.appname&coord_type=gcj02';
						break;
				default:
						break;
      }
			location.href=url
		}
	}
};
</script>
<style scoped>
	.introduce-content >>> img {
		max-width: 100%;
		height: auto;
	}
</style>
<style scoped lang="stylus">
.swiper-container
	--swiper-pagination-color #DE113C /* 两种都可以 */
.home-swiper
	width 100%
	height 400px
	.home-swiper-slide
		width 100%
		height 100%
		img
			width 100%
			height 100%
			object-fit: cover;
.office
	padding 24px 30px
	.name
		font-size 30px
		font-weight bold
		color #111111
	.openTime
		margin-top 20px
		margin-bottom 18px
		font-size 26px
		color #B1B1B1
		img
			width 26px
			height 26px
			margin-right 12px
	.location
		font-size 26px
		color #B1B1B1
		img
			width 22px
			height 26px
			margin-right 16px
	.contact
		padding 18px 24px
		width 100%
		height 96px
		background #F6F6F6
		border-radius 10px
		font-size 26px
		font-weight bold
		color #111111
		margin-top 40px
		margin-bottom 40px
		.contact-btn
			background-image url('~@/static/images/index/btnBG.png')
			background-size 100% 100%
			background-position center
			width 200px
			height 60px
			padding 0 26px
			font-size 24px
			color #FFFFFF
			img
				width 28px
				height 26px
				margin-right 12px
	.introduce
		width 100%
		background-image url('~@/static/images/my/apply-circle.png')
		background-position left top
		background-size 38px 46px
		background-repeat no-repeat
		padding-left 12px
		padding-top 6px
		font-size: 32px;
		font-weight: bold;
		color: #000000;
		margin-bottom 28px
	.introduce-content
		font-size 30px
		color #333
		line-height 48px
</style>
